import React, { ReactNode, useId } from 'react';

import { BaseCheckbox } from './BaseCheckbox';

import { cn } from '@/shared/lib/tailwind-merge';

export interface CheckboxProps {
    children?: ReactNode;
    className?: string;
    id?: string;
    name?: string;
    checked?: boolean;
    disabled?: boolean;
    onChange?: (checked: boolean) => void;
}

export const Checkbox: React.FC<CheckboxProps> = ({
    children,
    className,
    id,
    name,
    checked,
    onChange,
    disabled,
    ...props
}) => {
    const uniqueId = useId();

    return (
        <div className={cn('flex items-start space-x-2 gap-2', className)}>
            <BaseCheckbox
                id={id || uniqueId}
                checked={checked}
                onCheckedChange={onChange}
                disabled={disabled}
                data-testid={`${name}-checkbox`}
                {...props}
            />
            {children}
        </div>
    );
};
